// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R5UN1","right":"styles_right__2qzAp"};